import React from 'react';
import EditCourseLessons from 'Pages/EditCourseLessons';
import EditCourseInformation from 'Pages/EditCourseInformation';
import EditCourseMembers from 'Pages/EditCourseMembers';
import EditCourseDocuments from 'Pages/EditCourseDocuments';
import EditCoursePost from 'Pages/EditCoursePost';
import EditCourseSessions from 'Pages/EditCourseSessions';
import useTranslation from 'Hooks/useTranslation';
import { SESSION_PERMISSIONS, useHasPermission } from 'Utils/permissions';

const useTab = ({
  modules = [],
  currentPositionModule = 0,
  deleteModule,
  updateModule,
  isDraft,
  typeContent,
  addLesson,
  addLessonSession,
  addLessonAutoEvaluation,
  updateLesson,
  updateLessonSessionData,
  courseId,
  currentPositionLesson,
  deleteLesson,
  updateLessonData,
  setCourseName,
  alert,
  setAlert,
}) => {
  const { t2 } = useTranslation('EditCourse');
  const canReadSessions = useHasPermission(SESSION_PERMISSIONS.READ);

  const tabsTitle = [
    t2('BasicInformation'),
    t2('Lessons'),
    t2('Documents'),
    t2('Members'),
    ...(canReadSessions ? [t2('Sessions')] : []),
    t2('Post'),
  ];

  const pageEditCourseInformation = () => <EditCourseInformation handleNameChange={setCourseName} />;

  const pageEditCourseLessons = () => (
    <EditCourseLessons
      module={modules[currentPositionModule]}
      deleteModule={deleteModule}
      updateModule={updateModule}
      typeContent={typeContent}
      addLesson={addLesson}
      addLessonSession={addLessonSession}
      addLessonAutoEvaluation={addLessonAutoEvaluation}
      updateLesson={updateLesson}
      updateLessonSessionData={updateLessonSessionData}
      currentPositionLesson={currentPositionLesson}
      deleteLesson={deleteLesson}
      updateLessonData={updateLessonData}
      courseId={courseId}
      alert={alert}
      setAlert={setAlert}
    />
  );

  const pageEditCourseDocuments = () => <EditCourseDocuments courseId={courseId} />;

  const pageEditCourseMembers = () => <EditCourseMembers />;

  const pageEditCourseSessions = () => <EditCourseSessions courseId={courseId} />;

  const pageEditCoursePost = () => <EditCoursePost courseId={courseId} isDraft={isDraft} />;

  const pages = [
    pageEditCourseInformation,
    pageEditCourseLessons,
    pageEditCourseDocuments,
    pageEditCourseMembers,
    ...(canReadSessions ? [pageEditCourseSessions] : []),
    pageEditCoursePost,
  ];

  return {
    tabsTitle,
    pages,
  };
};

export default useTab;
